export default {
  currentContract: {
    ContractNo: '',
    PaymentDueDate: '',
    TotalPaymentAmount: '',
    NearestPaymentDate: '',
    InterestRate: '',
    Origin: '',
    LateFee: '',
    NumDayOverdue: '',
    ResidualAmount: '',
    IsHinoImage: false,
    Car: {
      CarManufacturer: '',
      Brand: '',
      YearModel: '',
      CarTypeName: '',
      ContractNo: '',
      PlateNo: '',
      BrandLogo: ''
    }
  }
}
